/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { Col } from '../../../base/Grid';

const hasAdditionalDisclaimers = (disclaimerFootnotes,
  customDisclaimers) => (disclaimerFootnotes && disclaimerFootnotes.length > 0) || (customDisclaimers && customDisclaimers.length > 0);

export const DisclaimerColStyled = styled(Col)`
${({
    disclaimerFootnotes,
    customDisclaimers,
    theme,
  }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    return css`
      padding-top: ${rem(16)};
      padding-bottom: ${rem(16)};
      column-count: ${mediumUp ? '2' : '1'};
      ${hasAdditionalDisclaimers(disclaimerFootnotes, customDisclaimers) && `
        column-count: 1;
      `}
      
    `;
  }
}
`;
